import React from "react";
import { LOGO_URL } from "../utils/constants";

const Footer = () => {
  return (
    <footer
      className="py-4 sm:py-6 md:py-8 mt-5 mb-0 w-full bottom-0"
      style={{
        background: "linear-gradient(45deg, #f3a683, #78e08f)",
        color: "black",
      }}
    >
      <div className="container mx-auto px-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
        <div className="col-span-2 sm:col-span-3 md:col-span-4 lg:col-span-1">
          <div className="flex items-center">
            <img src={LOGO_URL} alt="Food Panda Logo" className="h-8 w-8 sm:h-12 sm:w-12 mr-2" />
            <div>
              <h1 className="text-xl sm:text-2xl md:text-3xl font-semibold">Food Panda</h1>
              <p className="text-xs sm:text-sm">&copy; 2024 Food Panda Limited</p>
            </div>
          </div>
        </div>

        <div className="footer-column">
          <h3 className="font-bold text-base sm:text-lg mb-2">Company</h3>
          <ul className="text-sm space-y-1">
            <li>About Us</li>
            <li>Careers</li>
            <li>Team</li>
            <li>Food Panda Pro</li>
            <li>Food Panda Genie</li>
            <li>Minis</li>
          </ul>
        </div>

        <div className="footer-column">
          <h3 className="font-bold text-base sm:text-lg mb-2">Contact Us</h3>
          <ul className="text-sm space-y-1">
            <li>Help & Support</li>
            <li>Partner With Us</li>
            <li>Drive With Us</li>
          </ul>
          <h3 className="font-bold text-base sm:text-lg mt-4 mb-2">Legal</h3>
          <ul className="text-sm space-y-1">
            <li>Terms & Conditions</li>
            <li>Privacy Policy</li>
            <li>Cookie Policy</li>
          </ul>
        </div>

        <div className="footer-column">
          <h3 className="font-bold text-base sm:text-lg mb-2">Available in:</h3>
          <ul className="text-sm space-y-1">
            <li>Bhubaneswar</li>
            <li>Bangalore</li>
            <li>Delhi</li>
            <li>Mumbai</li>
            <li>Pune</li>
            <li>Hyderabad</li>
            <li>Chennai</li>
          </ul>
        </div>

        <div className="footer-column">
          <h3 className="font-bold text-base sm:text-lg mb-2">Life at Food Panda</h3>
          <ul className="text-sm space-y-1">
            <li>Explore with Food Panda</li>
            <li>News</li>
            <li>Snacks & More</li>
          </ul>
        </div>

        <div className="footer-social">
          <h3 className="font-bold text-base sm:text-lg mb-2 cursor-pointer">Social Links</h3>
          <div className="social-icons flex space-x-4 text-xl sm:text-2xl">
            <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="hover:text-blue-600">
              <i className="fa fa-linkedin"></i>
            </a>
            <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-pink-600">
              <i className="fa fa-instagram"></i>
            </a>
            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-blue-800">
              <i className="fa fa-facebook"></i>
            </a>
            <a href="https://www.pinterest.com" target="_blank" rel="noopener noreferrer" className="hover:text-red-600">
              <i className="fa fa-pinterest"></i>
            </a>
            <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400">
              <i className="fa fa-twitter"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
